import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { matchesSearch } from "@/lib/search";
/**
 * Filter for a list page, kept in the URL as `?q=` — that is how the global
 * search hands over what was picked, and a filtered list survives a reload.
 *
 * Which rows are visible is only worked out again when the query changes or
 * rows are added/removed, not on every edit: these pages save while you type,
 * and renaming a sound would otherwise make it vanish from the filtered list
 * mid-word.
 */
export function useListFilter(items, fields) {
    const [params, setParams] = useSearchParams();
    const query = params.get("q") ?? "";
    const setQuery = (value) => {
        const next = new URLSearchParams(params);
        if (value)
            next.set("q", value);
        else
            next.delete("q");
        setParams(next, { replace: true });
    };
    const idsKey = items.map((i) => i.id).join(",");
    const visibleIds = useMemo(() => (query.trim() ? new Set(items.filter((i) => matchesSearch(query, fields(i))).map((i) => i.id)) : null), [query, idsKey]);
    const filtered = visibleIds ? items.filter((i) => visibleIds.has(i.id)) : items;
    return { query, setQuery, filtered, total: items.length };
}
